
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { FlagsPermissionHubToHub } from "@/feature-flags/flags-permission-hub-to-hub";
import { Vue, Options } from "vue-class-component";

@Options({
  watch: {
    "$route.fullPath": {
      handler() {
        this.getActiveTabRect();
      },
      immediate: true
    },
    loading: {
      handler() {
        this.getActiveTabRect();
      },
      immediate: true
    }
  }
})
export default class HubToHub extends Vue {
  get tabs() {
    return  [
      {
        name: this.$t('hubToHub.inHub'),
        path: "/hub-to-hub/in-hub",
        refName: "inHub",
        permission: FlagsPermissionHubToHub.in_hub_list.isEnabled()
      },
      {
        name: this.$t('hubToHub.outHub'),
        path: "/hub-to-hub/out-hub",
        refName: "outHub",
        permission: FlagsPermissionHubToHub.out_hub_list.isEnabled()
      }
    ]
  };

  tabRect = new DOMRect();
  resizeObserver: any = null;

  get loading() {
    return MainAppController.loadingModal;
  }

  async mounted() {
    await this.$nextTick();
    this.getActiveTabRect();
    const containerElement = document.getElementById(
      "booking-v2-tab-container"
    );
    if (!containerElement) return;
    this.resizeObserver = new (window as any).ResizeObserver(() => {
      this.getActiveTabRect();
    });
    this.resizeObserver.observe(containerElement);
  }

  unmounted() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

  async getActiveTabRect() {
    await this.$nextTick();
    const $tabElementRef = this.$refs[
      this.tabs.find((tab) => tab.path === this.$route.fullPath)
        ?.refName as keyof HubToHub
    ] as any;
    if (!$tabElementRef) return new DOMRect();
    const $tabElement = $tabElementRef.$el as HTMLElement;
    this.tabRect = $tabElement.getBoundingClientRect();
  }
}
